import { CategoryName, DbId } from '@infotech-soe/metaschema';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { CategoryOpenMode } from '../../../models/category/category';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { AppState } from '../../../store/reducers/root';
import {
  getGraphDocId,
  getGraphNodes,
  getGraphShow,
} from '../../../store/selectors/graph';
import categoryActions from '../../../store/slices/category';
import { DictionaryEffectType } from '../../../store/slices/dictionary';
import graph from '../../../store/slices/graph';
import DocLinksGraphDialog from '../../components/graph/DocLinksGraphDialog';

const mapStateToProps = (state: AppState) => ({
  data: getGraphNodes(state),
  show: getGraphShow(state),
  docId: getGraphDocId(state),
});

const mapDispatchToProps = {
  onClose: graph.close,
  onOpenCategory: categoryActions.openDisplayMode,
  onOpen: graph.open,
};

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { onOpenCategory, onOpen, onClose }: typeof mapDispatchToProps
) => ({
  ...stateProps,
  onClose: () => onClose(),
  onItemOpen: (category: CategoryName, docIds: DbId[]) => {
    onOpenCategory({
      category,
      ui: {
        mode: CategoryOpenMode.DICTIONARY,
        effect: { type: DictionaryEffectType.DO_NOTHING },
        multiSelect: false,
      },
      inParams: {
        linksGraph: {
          mode: DocLinksMode.SINGLE,
          category,
          id: docIds,
        },
      },
    });
  },
  onRebuildEdges: (categoryName: CategoryName, docId: DbId) => {
    onOpen({ categoryName, docId });
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type DocLinksGraphDialogContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(DocLinksGraphDialog);
